import { ReportManager } from './report-manager';

/**
 * Global report manager instance
 */
let reportManager: ReportManager | null = null;

/**
 * Get the global report manager instance
 * @returns ReportManager instance
 * @throws Error if report manager is not initialized
 */
export function getReportManager(): ReportManager {
  if (!reportManager) {
    throw new Error('Report manager not initialized. Call setReportManager first.');
  }
  return reportManager;
}

/**
 * Set the global report manager instance
 * @param manager - ReportManager instance to set
 */
export function setReportManager(manager: ReportManager): void {
  reportManager = manager;
}
